import { render, staticRenderFns } from "./invoicerecord.vue?vue&type=template&id=7f8dff7b&scoped=true&"
import script from "./invoicerecord.vue?vue&type=script&lang=js&"
export * from "./invoicerecord.vue?vue&type=script&lang=js&"
import style0 from "./invoicerecord.vue?vue&type=style&index=0&id=7f8dff7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8dff7b",
  null
  
)

export default component.exports